import { View, Text, StyleSheet } from '@react-pdf/renderer';

type TCellData = { value: string; columnSpan?: number };

export type TComparisonTablePDFProps = {
  data: { [key: string]: string | TCellData }[];
  labels: { [key: string]: string };
};

export const ComparisonTablePDF = ({
  data,
  labels,
}: TComparisonTablePDFProps) => {
  const styles = StyleSheet.create({
    container: {
      marginTop: 10,
      borderTop: '1px solid rgba(186, 208, 221, 1)',
      borderRight: '1px solid rgba(186, 208, 221, 1)',
    },
    table: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    tableRow: {
      flexDirection: 'row',
    },
    cell: {
      padding: 7,
      borderBottom: '1px solid rgba(186, 208, 221, 1)',
      borderLeft: '1px solid rgba(186, 208, 221, 1)',
      textAlign: 'center',
      flex: 1,
    },
    labelCell: {
      fontFamily: 'Helvetica-Bold',
      textAlign: 'left',
      backgroundColor: 'rgba(238, 244, 247, 1)',
    },
    headerCell: {
      fontFamily: 'Helvetica-Bold',
      fontWeight: 'light',
      backgroundColor: 'rgba(238, 244, 247, 1)',
    },
  });

  const keys = Object.keys(labels);

  const renderRow = (key: string, isHeader = false) => {
    const baseCellStyle = isHeader
      ? { ...styles.cell, ...styles.headerCell }
      : styles.cell;

    return (
      <View key={key} style={styles.tableRow}>
        <Text style={[baseCellStyle, styles.labelCell]}>{labels[key]}</Text>
        {data.map((row, rowIndex) => {
          const cellData = row[key];

          if (typeof cellData === 'string') {
            return (
              <Text style={baseCellStyle} key={rowIndex}>
                {cellData}
              </Text>
            );
          } else if (typeof cellData === 'object' && cellData !== null) {
            const colSpan = cellData.columnSpan || 1;
            const cellStyle = { ...baseCellStyle, flex: colSpan };
            return (
              <Text style={cellStyle} key={rowIndex}>
                {cellData.value}
              </Text>
            );
          } else {
            return (
              <Text style={baseCellStyle} key={rowIndex}>
                -
              </Text>
            );
          }
        })}
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.table}>
        {renderRow(keys[0], true)}
        {keys.slice(1).map((key) => renderRow(key))}
      </View>
    </View>
  );
};
